function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.856.796L5.93 2.452l3.366 3.456H.692v2.34h8.604L5.93 11.704l1.926 1.656 5.67-6.282L7.856.796z",
  fill: "#007AFF"
});

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgMTQgMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03Ljg1NjAyIDAuNzk2MDIxTDUuOTMwMDIgMi40NTIwMkw5LjI5NjAyIDUuOTA4MDJIMC42OTIwMTdWOC4yNDgwMkg5LjI5NjAyTDUuOTMwMDIgMTEuNzA0TDcuODU2MDIgMTMuMzZMMTMuNTI2IDcuMDc4MDJMNy44NTYwMiAwLjc5NjAyMVoiIGZpbGw9IiMwMDdBRkYiLz4KPC9zdmc+Cg==";
export { SvgArrow as ReactComponent };